export default __webpack_public_path__ + "static/media/GoodMannerWithYourParents_03.9ff54161.png";